var map = {
	"./check_off.svg": 1536,
	"./check_on.svg": 596,
	"./data.svg": 5224,
	"./down_arrow.svg": 6856,
	"./eye_closed.svg": 5724,
	"./eye_visible.svg": 9324,
	"./lineColor_black.svg": 1516,
	"./lineColor_white.svg": 8676,
	"./list.svg": 6452,
	"./scaleMode_fixed.svg": 2588,
	"./scaleMode_sliding.svg": 2680,
	"./theme_blues.svg": 4424,
	"./theme_cool.svg": 4639,
	"./theme_cubehelix.svg": 9364,
	"./theme_redgreen.svg": 6180,
	"./theme_standard.svg": 9180,
	"./theme_warm.svg": 4804,
	"./view_contours.svg": 1148,
	"./view_grid.svg": 208,
	"./view_radii.svg": 9410,
	"./view_strips.svg": 5736,
	"./view_trees.svg": 4728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4964;